import React from 'react';
import { Typography } from '@mui/material';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageDialog from '../../utils/PageDialog';
import { COLORS } from '../rejestracja/formTheme';

const ContactFormConfirmation = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { lang } = useParams();
  return (
    <PageDialog title={t('contact_thx_title')} maxWidth={760}>
      <Typography sx={{ color: COLORS.text }}>
        {t('contact_thx_body1')}
      </Typography>
      <Typography sx={{ color: COLORS.muted, mt: 3 }}>
        <strong style={{ color: COLORS.text }}>
          {t('contact_thx_time_label')}
        </strong>
        <br />
        {t('contact_thx_time')}
      </Typography>
      <Typography sx={{ color: COLORS.muted, mt: 3 }}>
        <strong style={{ color: COLORS.text }}>
          {t('contact_thx_mail_label')}
        </strong>
        <br />
        {t('contact_thx_mail')}
      </Typography>
      <Typography sx={{ color: COLORS.muted, mt: 3 }}>
        {t('contact_thx_faq')}{' '}
        <Link
          to={`/${lang}/terms/faqs`}
          state={{ previousLocation: location }}
          style={{ color: COLORS.accent, textDecoration: 'underline' }}
        >
          {t('page_faqs')}
        </Link>
        .
      </Typography>
    </PageDialog>
  );
};

export default ContactFormConfirmation;
